import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect';
import { getProffitSearchValues } from '../../helpers/profile';
import { useSlideSearchRegenerateDevice } from '../../helpers/use/proffit_search/common/useSlideSearchRegenerateDevice';
import { useUnmountRef } from '../../helpers/use/useHook';
import Layout from '../Layout';
import SlideSearchRegenerateDeviceCompleteModal from './RegenerateDevice/Modal/SlideSearchRegenerateDeviceCompleteModal';
import SlideSearchRegenerateDeviceModal from './RegenerateDevice/Modal/SlideSearchRegenerateDeviceModal';
const SlideSearchRegenerateDevice = () => {
    const profile = useSelector((state) => state.profile);
    const email = profile ? profile.email : '';
    const userDevice = useSelector((state) => state.proffitSearchDevice.userDevice);
    const redirectTo = useMemo(() => {
        const { enableProffitSearch, userAllowDeviceId } = getProffitSearchValues(profile);
        // 使用許可がない
        if (!enableProffitSearch) {
            return '/';
        }
        // 端末割り当て済み
        if (userAllowDeviceId && userDevice && userAllowDeviceId === userDevice) {
            return '/proffit_search/search';
        }
        return '';
    }, [profile, userDevice]);
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const { isShowCompleteModal, isShowRegenerateModal, loading, onClickRegenerate, } = useSlideSearchRegenerateDevice.useSlideSearchRegenerateDeviceModal(true, dispatch, unmountRef);
    if (redirectTo) {
        return _jsx(CustomRedirect, { to: '/proffit_search' });
    }
    return (_jsxs(Layout, Object.assign({ isLoading: true, mainClassName: 'l-main slide_search_regenerate_device_page' }, { children: [_jsx(SlideSearchRegenerateDeviceModal, { isShow: isShowRegenerateModal, loading: loading, onClick: onClickRegenerate }), _jsx(SlideSearchRegenerateDeviceCompleteModal, { email: email, isShow: isShowCompleteModal })] })));
};
export default SlideSearchRegenerateDevice;
